import { ApiHelper } from './api.helper';
import { IStaffEvolution } from '../types/staff-evolution.type';
import { HttpUtils } from '../utils/http.utils';
import { IFilters, IRequestParams } from '../views/StaffEvolution/types';

export const fetchStaffEvolution = async (filters: IFilters): Promise<IStaffEvolution[]> => {
  const queryParams = HttpUtils.toQueryParams<IFilters, IRequestParams>(filters);
  const url = `${ApiHelper.makeUrl('staff/evolution')}?${queryParams}`;
  const response = await fetch(url, ApiHelper.makeOptions());
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data;
};

export const downloadStaffEvolution = async (filters: IFilters): Promise<Blob> => {
  const queryParams = HttpUtils.toQueryParams<IFilters, IRequestParams>(filters);
  const url = `${ApiHelper.makeUrl('staff/evolution/export')}?${queryParams}`;

  const response = await fetch(url, ApiHelper.makeOptions());
  const data = response.blob();

  if (!response.ok) {
    const responseData = await response.json();

    throw new Error(await responseData.message);
  }

  return data;
};
